import { Link } from 'react-router-dom';

export default function StatCard({ label, value, hint, tone = 'neutral', to }) {
  const content = <><span>{label}</span><strong>{value}</strong><small>{hint}</small></>;
  return to
    ? <Link className={`stat-card tone-${tone} stat-card-link`} to={to}>{content}</Link>
    : <article className={`stat-card tone-${tone}`}>{content}</article>;
}
